/** URL base da API de backend, injetada em build-time pelo webpack a partir do `.env`. */
export const API_BASE_URL = process.env.API_BASE_URL || "http://localhost:8000/api";

/** Token Bearer usado para autenticar o add-in na API de backend, injetado em build-time pelo webpack a partir do `.env`. */
export const API_TOKEN = process.env.API_TOKEN || "";

/**
 * Identificador do build (SHA curto do commit + horário), injetado em build-time
 * pelo webpac.
 */
export const BUILD_ID = process.env.BUILD_ID || "dev";
